import {get, post} from "./request";

const apiResource = "/invoice";
export const invoiceApi = {};

invoiceApi.getAll = async ({page, size, ...props}) => {
  try {
    const {data} = await post(apiResource + `/all`, props, {
      page,
      size,
    });
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

invoiceApi.getFile = async (invoiceId) =>
  get(`${apiResource}/${invoiceId}/file`, {}, {responseType: "blob"});

invoiceApi.getProviderFile = async (invoiceId) =>
  get(`${apiResource}/${invoiceId}/provider-file`, {}, {responseType: "blob"});

invoiceApi.uploadProviderInvoice = async (invoiceId, file, onUploadProgress) => {
  const form = new FormData();
  form.append("invoice", file);
  const {data} = await post(
    `${apiResource}/${invoiceId}/provider-upload`,
    form,
    {},
    {onUploadProgress},
  );
  return data;
};
